import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Setup API base URL
const API = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

// Set token in headers
API.interceptors.request.use((req) => {
  const token = localStorage.getItem('token');
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

// Submit Contact Form
export const submitContactForm = createAsyncThunk<
  any,
  { name: string; email: string; subject: string; comments: string },
  { rejectValue: string } 
>(
  'contact/submitForm',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await API.post('/contact/submit', formData);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to submit contact form');
    }
  }
);
